import { Skeleton } from '@cian/ui-kit/skeleton';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './OfferPreviewLoading.css';
import { ETestId } from '../../../../constants/testId';

export interface IOfferPreviewLoadingProps {
  className?: string;
  isCompact?: boolean;
}

export const OfferPreviewLoading = ({ className, isCompact = false }: IOfferPreviewLoadingProps) => {
  return (
    <div data-testid={ETestId.OfferPreviewLoading} className={cn(styles['root'], className)}>
      <div className={cn(styles['photo'], isCompact && styles['photo--compact'])}>
        <Skeleton width="100%" height="100%" borderRadius={0} />
      </div>
      <div className={styles['content']}>
        <Skeleton width={179} height={24} borderRadius={12} />
        <Skeleton width="100%" height={88} borderRadius={12} />
      </div>
    </div>
  );
};
